namespace GeniuzPOS.AdvPromo {
@Serenity.Decorators.registerClass()
export class Adv05ItemDetailEditor extends Serenity.Extensions.GridEditorBase<Adv05ItemDetailRow> {
    protected getColumnsKey() { return Adv05ItemDetailColumns.columnsKey; }
    protected getDialogType() { return Adv05ItemDetailDialog; }
    protected getLocalTextPrefix() { return Adv05ItemDetailRow.localTextPrefix; }
    protected getService() { return Adv05ItemDetailService.baseUrl; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
        // buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
        //     grid: this,
        //     service: Adv05ItemDetailService.baseUrl + '/ListExcel',
        //     onViewSubmit: () => true,
            
        //     separator: true
        // }));

        // buttons.push(
        //     {
        //         title: 'Export',
        //             cssClass: 'button-export',
        //             icon: 'fa-cloud-download',
        //             onClick: () => {
        //                 let _orderDetailsRows: Adv05ItemDetailRow[] = [];
        //                 this.view.getItems().forEach((v, i) => {
        //                     _orderDetailsRows.push();
        //                 });;
        //                 Q.postToService({
        //                     service: Adv05ItemDetailService.baseUrl + '/ListExcel',
        //                     request: {
        //                         Adv05ItemDetailRow: _orderDetailsRows,
        //                     },
        //                     target: '_blank'
        //                 });
        //             }
        //     }
        // );
       
        return buttons;
    }



    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

    

    
}}